import { alpha } from '@mui/material';
import { CellClassParams } from 'ag-grid-community';
import { camelize } from 'helpers/syntaxHelper';
import { PreviewColumnT } from 'routes/Cellar/types';
import { MANTY_LIGHT_GREY, MANTY_RED } from 'styles/theme';

const getCellBackgroundColor = (
    value: string,
    type: string,
    types: Partial<DataTypesT>,
): string | null => {
    if (!value) {
        return MANTY_LIGHT_GREY;
    }
    if (!types.includes(type)) {
        return alpha(MANTY_RED, 0.5);
    }
    return null;
};
export const previewCellStyle = (
    column: PreviewColumnT,
    type: string,
    params: CellClassParams,
) => {
    const { value, types } = params.data[camelize(column.name)];
    return {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: getCellBackgroundColor(value, type, types) || '#fff',
    };
};
